module.exports = __webpack_public_path__ + "img/txt5.d652e336.png";